export type MessagesFlyoutEntityTarget = {
  entityType: string;
  entityId: string;
  audience: 'INTERNAL' | 'CLIENT';
};

export type MessagesFlyoutDraftReference = {
  refType: string;
  refId: string;
  label?: string | null;
};

export type OpenMessagesFlyoutRequest = {
  conversationId?: string | null;
  openEntity?: MessagesFlyoutEntityTarget | null;
  /** @deprecated prefer draftReferences */
  draftReference?: MessagesFlyoutDraftReference | null;
  draftReferences?: MessagesFlyoutDraftReference[] | null;
};

export function resolveFlyoutDraftReferences(
  request: Pick<OpenMessagesFlyoutRequest, 'draftReference' | 'draftReferences'>,
): MessagesFlyoutDraftReference[] {
  const merged = [...(request.draftReferences ?? [])];
  if (request.draftReference) merged.push(request.draftReference);
  const seen = new Set<string>();
  return merged.filter((ref) => {
    const key = `${ref.refType}:${ref.refId}`;
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
}

const OPEN_MESSAGES_FLYOUT_EVENT = 'admin:open-messages-flyout';

export function openMessagesFlyout(request: OpenMessagesFlyoutRequest = {}): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent<OpenMessagesFlyoutRequest>(OPEN_MESSAGES_FLYOUT_EVENT, { detail: request }));
}

export function onOpenMessagesFlyout(
  listener: (request: OpenMessagesFlyoutRequest) => void,
): () => void {
  if (typeof window === 'undefined') return () => {};
  const handle = (event: Event) => {
    listener((event as CustomEvent<OpenMessagesFlyoutRequest>).detail ?? {});
  };
  window.addEventListener(OPEN_MESSAGES_FLYOUT_EVENT, handle);
  return () => window.removeEventListener(OPEN_MESSAGES_FLYOUT_EVENT, handle);
}
